import React from 'react'
import HomeItem from './HomeItem'
import HomeBanner from './HomeBanner'
// import home-new from './home-new.css'
import './Home.css'

const Home = () => {

  return (
    <>
      {/* <HomeBanner /> */}

      <div className="container">
      <main>
        <div className="w-full max-w-screen-xl mx-auto">
          <nav className="container mx-auto p-6" aria-label="Fil d’Ariane">
            <ul className="page-breadcrumb flex gap-2 items-center justify-start text-davys">
              <li className="underline" style={{ color: '#4B4B4A' }}>
                <a href="https://www.rullier.fr/" className="cursor-pointer">
                  Accueil
                </a>
              </li>
              <li aria-hidden="true" style={{ color: '#4B4B4A' }}>›</li>
              <li className="underline" style={{ color: '#4B4B4A' }}>
                <a href="../index.html" className="cursor-pointer">
                  Outils en ligne
                </a>
              </li>
              <li aria-hidden="true" style={{ color: '#4B4B4A' }}>›</li>
              <li aria-current="page" style={{ color: '#4B4B4A' }}>Bureau d'Études</li>
            </ul>
          </nav>
          <div className="container mx-auto px-6 grid justify-content-end">
            <a
              href="https://puc.ova-consulting.fr/"
              className="cursor-pointer w-fit h-fit rounded-full py-2 px-4 flex justify-between items-center border border-davys/10 text-davys gap-2 hover:bg-davys/70 hover:text-white transition-transform duration-300 ease-out hover:-translate-y-1"
            >
              <img src='../assets/images/arrow-left.png' alt="Retour à tous les outils" width={'25px'}/>
              
              <span className="text-sm">Retour à tous les outils</span>
            </a>
          </div>
          <div className="container mx-auto p-6 grid gap-12">
            <h1 className="text-davys text-4xl font-semibold leading-14">
              Les outils en ligne de notre Bureau d'Études Bois
            </h1>
            <div className="text-davys grid gap-2">
              <p>
                Professionnels ou Particuliers, profitez de nos outils dédiés pour la
                réalisation de tous vos projets.
              </p>
              <p>
                Le{" "}
                <a
                  href="https://www.rullier.fr/bureau-d-etudes.html"
                  className="font-bold text-chamoisee hover:underline"
                >
                  Bureau d'Études Rullier Bois
                </a>{" "}
                est le spécialiste de la construction bois depuis plus de 20 ans. Nous
                concevons et dimensionnons vos projets{" "}
                <span className="font-semibold">
                  de surélévation maison bois, extension bois, maison ossature bois,
                  charpente traditionnelle ou industrielle, pergola, carport, préau et
                  toute structure bois
                </span>
                dans le respect des normes.
              </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-7 gap-16 mt-6 items-start">
              <div className="col-span-1 lg:col-span-2">
                <div className="h-96">
                  <img
                    src="../assets/images/rullier-bois-bureau-d-etude.jpg"
                    alt="Illustration Demande d'études Rulliers Bois"
                    className="h-full w-full object-cover rounded-2xl h-100"
                  />
                </div>
              </div>
              
              <div className="col-span-1 lg:col-span-5">
                <div className="grid gap-8">
                  <h2 className="text-davys text-3xl">Demande d'étude, chiffrage</h2>
                  <div className="text-center" style={{ marginBottom: 0 }}>
                    <div className="row">
                      {/* {isLoading && <p className='text-center'>Loading projects...</p>}
                      {error && <p className='text-center'>Error Loading projects.</p>} */}
                      <HomeItem/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full mt-24 bg-chamoisee/5">
          <div className="w-full max-w-screen-xl mx-auto py-24">
            <div className="container mx-auto p-6">
              <h2 className="text-chamoisee text-4xl leading-12" style={{color: '#988363', fontWeight: 'inherit'}}>
                Le Bureau d'Études Rullier Bois,
                <br />{" "}
                <span className="font-semibold">
                  Spécialiste de la construction bois
                </span>{" "}
                depuis 20 ans
              </h2>
              <div className="grid grid-cols-1 lg:grid-cols-7 items-end gap-16 mt-12">
                <div className="col-span-1 lg:col-span-3 h-96">
                  {/* Slider main container */}
                  <div className="swiper">
                    {/* Additional required wrapper */}
                    <div className="swiper-wrapper">
                      {/* Slides */}
                      <div className="swiper-slide">
                        <div className="h-96">
                          <img
                            src="../assets/images/rullier-R180.jpg"
                            alt="Rullier R180"
                            className="h-full w-full object-cover rounded-2xl"
                          />
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="h-96">
                          <img
                            src="../assets/images/fermette-rullier.jpg"
                            alt="Fermette Rullier"
                            className="h-full w-full object-cover rounded-2xl"
                          />
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="h-96">
                          <img
                            src="../assets/img/yourte.jpg"
                            alt="Yourte"
                            className="h-full w-full object-cover rounded-2xl"
                          />
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="h-96">
                          <img
                            src="../assets/img/charpente-chene.jpg"
                            alt="Charpente Chene"
                            className="h-full w-full object-cover rounded-2xl"
                          />
                        </div>
                      </div>
                    </div>
                    {/* If we need pagination */}
                    <div className="swiper-pagination" />
                  </div>
                </div>
                <div className="col-span-1 lg:col-span-4">
                  <div className="grid gap-8 text-davys">
                    <p>
                      Depuis plus de 20 ans, le Bureau d’Études Construction Bois
                      Rullier Bois{" "}
                      <strong>conçoit et dimensionne tous types de projets</strong> :
                      surélévation, extension, maison ossature bois, charpente,
                      pergola, carport… Nos ingénieurs réalisent des{" "}
                      <strong>calculs précis</strong> conformes aux Eurocodes et DTU,{" "}
                      <strong>optimisent les sections</strong> et{" "}
                      <strong>
                        livrent des plans d’exécution clairs ainsi que des kits bois
                        prêts à monter pour
                      </strong>{" "}
                      des chantiers fiables, rapides et sans surprise.
                    </p>
                    <p>
                      Fort de 140 ans d’expertise dans le bois,{" "}
                      <a
                        href="https://www.rullier.fr/a-propos.html"
                        className="font-bold text-chamoisee hover:underline"
                      >
                        Rullier Bois
                      </a>{" "}
                      accompagne artisans et constructeurs avec un savoir-faire
                      reconnu et un profond respect de la ressource. De l’étude
                      structurelle à la fabrication en passant par le métré et la
                      modélisation 3D, nous sécurisons vos projets en{" "}
                      <strong>construction neuve comme en rénovation</strong>, au plus
                      près de vos chantiers.
                    </p>
                    <div className="w-full flex justify-start">
                      <a
                        href="https://www.rullier.fr/bureau-d-etudes.html"
                        className="w-fit rounded-full py-2 px-4 flex justify-between items-center border border-chamoisee/10 text-chamoisee gap-2 hover:bg-chamoisee/70 hover:text-white transition-transform duration-300 ease-out hover:-translate-y-1"
                      >
                        <span className="text-sm">Allez plus loin</span>
                        <img src='../assets/images/arrow-right.png' alt="Allez plus loin" width={'25px'}/>
                        
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container mx-auto px-6 py-24">
          <h2 className="text-davys text-4xl leading-12" style={{fontWeight: 'inherit'}}>
            Allons plus loin ensemble ! Nous vous accompagnons <br />
            <span className="font-semibold">
              du cahier des charges à la fin de chantier
            </span>
            .
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mt-16 mt-0 relative lg:my-24">
            <div className="col-span-1 lg:h-84 lg:sticky lg:top-24 grid gap-16" style={{marginTop: '65px'}}>
              <img
                src="../assets/images/rullier-bois-bureau-d-etude-illustration.jpg"
                className="h-full w-full object-cover rounded-2xl"
              />
            </div>
            <div className="col-span-1 grid gap-8 lg:px-18">
              <div>
                <h3 className="text-3xl text-chamoisee mb-1">
                  <span className="font-semibold text-7xl">1.</span>
                  <br /> Devis et Informations
                </h3>
                <p className="text-davys">
                  Nous analysons votre besoin, étudions vos plans et vous fournissons
                  un devis clair et détaillé, adapté à votre projet bois.{" "}
                </p>
              </div>
              <div>
                <h3 className="text-3xl text-chamoisee mb-1">
                  <span className="font-semibold text-7xl">2.</span>
                  <br /> Étude et Modélisation
                </h3>
                <p className="text-davys">
                  Nos ingénieurs dimensionnent votre structure selon les normes
                  (Eurocodes, DTU) et modélisent votre projet en 3D pour garantir
                  précision et fiabilité{" "}
                </p>
              </div>
              <div>
                <h3 className="text-3xl text-chamoisee mb-1">
                  <span className="font-semibold text-7xl">3.</span>
                  <br /> Vente et Livraison
                </h3>
                <p className="text-davys">
                  Nous fabriquons votre kit bois sur mesure en atelier et assurons une
                  livraison rapide et sécurisée, au plus près de votre chantier.
                </p>
              </div>
              <div>
                <h3 className="text-3xl text-chamoisee mb-1">
                  <span className="font-semibold text-7xl">4.</span>
                  <br /> Conseils et Disponibilité
                </h3>
                <p className="text-davys">
                  Vous êtes accompagnés à chaque étape : choix techniques,
                  optimisation, montage… Notre équipe reste disponible pour répondre
                  rapidement à vos questions.
                </p>
              </div>
              <div>
                <h3 className="text-3xl text-chamoisee mb-1">
                  <span className="font-semibold text-7xl">5.</span>
                  <br /> Fin de chantier et Résultat
                </h3>
                <p className="text-davys">
                  Vos plans et kits bois optimisés garantissent un montage simple et
                  une structure solide, durable et conforme à votre vision
                  finale.
                </p>
              </div>
              <div className="w-full grid gap-6 justify-start mt-12">
                <a
                  href="https://www.rullier.fr/nous-contacter.html"
                  className="w-fit rounded-full py-2 px-3 flex justify-between items-center border border-chamoisee/10 hover:text-chamoisee gap-2 bg-chamoisee/70 hover:bg-transparent text-white transition-transform duration-300 ease-out hover:-translate-y-1"
                >
                  <span className="text-sm">
                    Contactez le Bureau d'Études construction bois
                  </span>
                  <img src='../assets/images/arrow-right.png' alt="Allez plus loin" width={'20px'}/>
                  
                </a>
                <a
                  href="https://www.rullier.fr/services.html"
                  className="w-fit rounded-full py-2 px-3 flex justify-between items-center border border-chamoisee/10 text-chamoisee gap-2 hover:bg-chamoisee/70 hover:text-white transition-transform duration-300 ease-out hover:-translate-y-1"
                >
                  <span className="text-sm">Consultez tous nos services</span>
                  <img src='../assets/images/arrow-right.png' alt="Allez plus loin" width={'20px'}/>
                  
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="container mx-auto px-6 pt-16 pb-24 border-t-1 border-davys/10">
          <div className="grid grid-cols-1 items-center justify-between gap-12">
            <h2 className="text-davys text-4xl leading-12 text-center" style={{fontWeight: 'inherit'}}>
              <span className="font-semibold">Toutes vos questions </span>
              sur les outils en ligne Bureau Étude construction bois
            </h2>
            <section className="mx-auto w-full space-y-5">
              <details className="group border border-davys/10 rounded-2xl p-6">
                <summary className="flex cursor-pointer list-none items-center justify-between">
                  <span className="text-lg text-davys">
                    À quoi sert une demande d’étude et de chiffrage bois en
                    Poitou-Charentes ?
                  </span>
                  <span className="transition-transform group-open:rotate-45 text-2xl leading-none text-davys">
                    +
                  </span>
                </summary>
                <div className="mt-3 text-davys">
                  La demande d’étude et de chiffrage bois permet d’obtenir une analyse
                  technique et une estimation précise des matériaux nécessaires à
                  votre projet en Poitou-Charentes et plus largement en
                  Nouvelle-Aquitaine. Elle constitue une première étape pour sécuriser
                  la faisabilité et le budget.
                </div>
              </details>
              <details className="group border border-davys/10 rounded-2xl p-6">
                <summary className="flex cursor-pointer list-none items-center justify-between">
                  <span className="text-lg text-davys">
                    Quels projets bois sont étudiés par le bureau d’études Rullier
                    Bois ?
                  </span>
                  <span className="transition-transform group-open:rotate-45 text-2xl leading-none text-davys">
                    +
                  </span>
                </summary>
                <div className="mt-3 text-davys">
                  Le bureau d’études Rullier Bois accompagne les projets de charpente
                  traditionnelle, solivage et dalle bois, ossature bois et extension,
                  fermettes, surélévation, carports, pergolas et terrasses bois, pour
                  les professionnels et particuliers de Poitou-Charentes.
                </div>
              </details>
              <details className="group border border-davys/10 rounded-2xl p-6">
                <summary className="flex cursor-pointer list-none items-center justify-between">
                  <span className="text-lg text-davys">
                    Quelle solution choisir entre charpente traditionnelle et fermette
                    ?
                  </span>
                  <span className="transition-transform group-open:rotate-45 text-2xl leading-none text-davys">
                    +
                  </span>
                </summary>
                <div className="mt-3 text-davys">
                  La charpente traditionnelle offre une grande liberté architecturale,
                  souvent recherchée dans les projets de rénovation ou de construction
                  sur mesure. La fermette est une solution industrialisée, économique
                  et rapide, fréquemment utilisée pour des maisons neuves en
                  Nouvelle-Aquitaine.
                </div>
              </details>
              <details className="group border border-davys/10 rounded-2xl p-6">
                <summary className="flex cursor-pointer list-none items-center justify-between">
                  <span className="text-lg text-davys">
                    Dans quels cas réaliser une étude de solivage ou de dalle bois ?
                  </span>
                  <span className="transition-transform group-open:rotate-45 text-2xl leading-none text-davys">
                    +
                  </span>
                </summary>
                <div className="mt-3 text-davys">
                  Une étude de solivage ou de dalle bois est recommandée pour les
                  planchers, mezzanines et niveaux intermédiaires, en neuf comme en
                  rénovation. Elle garantit la solidité et le confort des ouvrages
                  bois réalisés en Poitou-Charentes.
                </div>
              </details>
              <details className="group border border-davys/10 rounded-2xl p-6">
                <summary className="flex cursor-pointer list-none items-center justify-between">
                  <span className="text-lg text-davys">
                    À quoi correspond une étude ossature bois ou extension ?
                  </span>
                  <span className="transition-transform group-open:rotate-45 text-2xl leading-none text-davys">
                    +
                  </span>
                </summary>
                <div className="mt-3 text-davys">
                  L’étude ossature bois concerne les extensions et constructions bois
                  complètes. Elle permet de dimensionner les murs porteurs et
                  structures dans le respect des contraintes techniques et climatiques
                  propres à la région Nouvelle-Aquitaine.
                </div>
              </details>
              <details className="group border border-davys/10 rounded-2xl p-6">
                <summary className="flex cursor-pointer list-none items-center justify-between">
                  <span className="text-lg text-davys">
                    Peut-on chiffrer un projet de surélévation bois en
                    Poitou-Charentes ?
                  </span>
                  <span className="transition-transform group-open:rotate-45 text-2xl leading-none text-davys">
                    +
                  </span>
                </summary>
                <div className="mt-3 text-davys">
                  Oui. Le bureau d’études Rullier Bois réalise des études de
                  surélévation bois en tenant compte des charges existantes, des
                  contraintes du bâti et des réglementations locales, avec une
                  approche sécurisée et adaptée au contexte régional.
                </div>
              </details>
              <details className="group border border-davys/10 rounded-2xl p-6">
                <summary className="flex cursor-pointer list-none items-center justify-between">
                  <span className="text-lg text-davys">
                    Les carports, pergolas et terrasses bois sont-ils concernés ?
                  </span>
                  <span className="transition-transform group-open:rotate-45 text-2xl leading-none text-davys">
                    +
                  </span>
                </summary>
                <div className="mt-3 text-davys">
                  Oui. Les projets de carports, pergolas et terrasses bois peuvent
                  être étudiés et chiffrés afin de définir les sections, essences et
                  fixations adaptées aux usages extérieurs et aux conditions
                  climatiques locales.
                </div>
              </details>
              <details className="group border border-davys/10 rounded-2xl p-6">
                <summary className="flex cursor-pointer list-none items-center justify-between">
                  <span className="text-lg text-davys">
                    Je ne trouve pas mon projet bois, comment faire ?
                  </span>
                  <span className="transition-transform group-open:rotate-45 text-2xl leading-none text-davys">
                    +
                  </span>
                </summary>
                <div className="mt-3 text-davys">
                  Si votre projet bois ne correspond pas aux catégories proposées,
                  sélectionnez “Je ne trouve pas mon projet”. Le bureau d’études
                  Rullier Bois analysera votre demande et vous orientera vers la
                  solution la plus adaptée, en Poitou-Charentes ou ailleurs en France.
                </div>
              </details>
              <details className="group border border-davys/10 rounded-2xl p-6">
                <summary className="flex cursor-pointer list-none items-center justify-between">
                  <span className="text-lg text-davys">
                    À qui s’adressent les études bois Rullier Bois ?
                  </span>
                  <span className="transition-transform group-open:rotate-45 text-2xl leading-none text-davys">
                    +
                  </span>
                </summary>
                <div className="mt-3 text-davys">
                  Les études et chiffrages bois s’adressent aux artisans,
                  charpentiers, constructeurs, maîtres d’œuvre et particuliers situés
                  en Poitou-Charentes et en Nouvelle-Aquitaine, avec un accompagnement
                  adapté à chaque profil.
                </div>
              </details>
              <details className="group border border-davys/10 rounded-2xl p-6">
                <summary className="flex cursor-pointer list-none items-center justify-between">
                  <span className="text-lg text-davys">
                    Que se passe-t-il après l’envoi de ma demande d’étude bois ?
                  </span>
                  <span className="transition-transform group-open:rotate-45 text-2xl leading-none text-davys">
                    +
                  </span>
                </summary>
                <div className="mt-3 text-davys">
                  Après réception de votre demande, le bureau d’études Rullier Bois
                  vous recontacte pour valider les informations, préciser le périmètre
                  de l’étude et vous communiquer les délais de traitement, en lien
                  avec votre agence locale.
                </div>
              </details>
            </section>
          </div>
        </div>
      </main>
    {/* Steps */}
    {/* <section className="nos-attouts mb-5">
      <div className="container">
        <div className="flex-box flex-5">
          <div className="box-item mb-5">
            <div className="d-flex flex-column">
              <div className="icon">
                <span>01</span>
                <img src="/assets/images/icons/service.svg" alt="" />
              </div>
              <div className="title">
                SERVICE <br />
                CONSEIL
              </div>
              <div className="text">Nos experts produits à votre disposition</div>
            </div>
          </div>
          <div className="box-item mb-5">
            <div className="d-flex flex-column">
              <div className="icon">
                <span>02</span>
                <img src="/assets/images/icons/decoupe.svg" alt="" />
              </div>
              <div className="title">
                DÉCOUPE <br />
                TRANSFORMATION
              </div>
              <div className="text">
                Une réponse aux demandes de sur-mesure et standard
              </div>
            </div>
          </div>
          <div className="box-item mb-5">
            <div className="d-flex flex-column">
              <div className="icon">
                <span>03</span>
                <img src="/assets/images/icons/stock.svg" alt="" />
              </div>
              <div className="title">
                STOCK ET <br />
                DISPONIBILITÉ
              </div>
              <div className="text">
                Retrouvez en ligne tous nos produits et toutes nos offres
              </div>
            </div>
          </div>
          <div className="box-item mb-5">
            <div className="d-flex flex-column">
              <div className="icon">
                <span>04</span>
                <img src="/assets/images/icons/delivr.svg" alt="" />
              </div>
              <div className="title">
                SERVICE <br />
                LIVRAISON
              </div>
              <div className="text">
                Livraison assurée en Nouvelle Aquitaine et Pays de la Loire
              </div>
            </div>
          </div>
          <div className="box-item mb-5">
            <div className="d-flex flex-column">
              <div className="icon">
                <span>05</span>
                <img src="/assets/images/icons/payment.svg" alt="" />
              </div>
              <div className="title">
                PAIEMENT <br />
                SÉCURISÉ
              </div>
              <div className="text">Avec le protocole 3D secure 2.0</div>
            </div>
          </div>
        </div>
      </div>
    </section> */}
      </div>

      {/* <section
        className="forest"
        style={{ backgroundImage: "url(/assets/images/forest.png)" }}
      >
        <div className="bg h-100" />
      </section> */}


    </>
  )
}

export default Home